export const codingTools = [
  {
    name: "HTML",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/HTML5_logo_and_wordmark.svg").default}
      ></img>
    ),
    rate: "90%",
  },
  {
    name: "CSS",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/CSS3_logo_and_wordmark.png")}
      ></img>
    ),
    rate: "90%",
  },
  {
    name: "Javascript",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/Js.svg").default}
      ></img>
    ),
    rate: "85%",
  },
  {
    name: "React",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/React-icon.svg").default}
      ></img>
    ),
    rate: "85%",
  },
  {
    name: "Vue",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/React-icon.svg").default}
      ></img>
    ),
    rate: "85%",
  },
  {
    name: "Python",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/React-icon.svg").default}
      ></img>
    ),
    rate: "40%",
  },
  {
    name: "Ansible",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/React-icon.svg").default}
      ></img>
    ),
    rate: "40%",
  },
  {
    name: "NodeJS",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/Node.js_logo.svg").default}
      ></img>
    ),
    rate: "40%",
  },
  {
    name: "Golang",
    icon: "",
    rate: "35%",
  },
  {
    name: "Docker",
    icon: "",
    rate: "25%",
  },
  {
    name: "Kubernetes",
    icon: "",
    rate: "25%",
  },
  {
    name: "Express",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/Express_Logo.png")}
      ></img>
    ),
    rate: "40%",
  },
  {
    name: "MongoDB",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/MongoDB_Logo.svg").default}
      ></img>
    ),
    rate: "35%",
  },
  {
    name: "Git",
    icon: (
      <img
        alt="tool-icon-img"
        className="AboutMeSkillsAndTools-toolIcon2"
        src={require("../assets/Git-logo.svg").default}
      ></img>
    ),
    rate: "85%",
  },
];